import { type AllergenTypes } from '../setup/types';

// ─────────────────────────────────────────────────────────────────────────────

export function checkIfHasSelectedPreferences(preferences: AllergenTypes) {
  return Object.values(preferences).some(Boolean);
}
